// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface Descriptor
 */
export interface Descriptor {
  /**
   *
   */
  dataType?: string | null;
  /**
   *
   */
  layers?: Array<{ [key: string]: any }>;
  /**
   *
   */
  status: any | null;
  /**
   *
   */
  allowsMapLayer?: boolean;
  /**
   *
   */
  meta?: { [key: string]: any } | null;
}

/**
 * Check if a given object implements the Descriptor interface.
 */
export function instanceOfDescriptor(value: object): value is Descriptor {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function DescriptorFromJSON(json: any): Descriptor {
  return DescriptorFromJSONTyped(json, false);
}

export function DescriptorFromJSONTyped(json: any, ignoreDiscriminator: boolean): Descriptor {
  if (json == null) {
    return json;
  }
  return {
    dataType:
      json["data_type"] === undefined
        ? undefined
        : json["data_type"] === null
        ? null
        : json["data_type"],
    layers: json["layers"] == null ? undefined : json["layers"],
    status: json["status"],
    allowsMapLayer: json["allows_map_layer"] == null ? undefined : json["allows_map_layer"],
    meta: json["meta"] === undefined ? undefined : json["meta"] === null ? null : json["meta"],
  };
}

export function DescriptorToJSON(json: any): Descriptor {
  return DescriptorToJSONTyped(json, false);
}

export function DescriptorToJSONTyped(
  value?: Descriptor | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    data_type: value["dataType"],
    layers: value["layers"],
    status: value["status"],
    allows_map_layer: value["allowsMapLayer"],
    meta: value["meta"],
  };
}
